import React, { Component } from 'react';
import './styles.css';
import Row from '../Row';
import Col from '../Col';

class Header extends Component {
	render() {
		return (
			<div className="three-years-table-layout-header">
				<Row>
					<Col />
					<Col>YEAR 1</Col>
					<Col>YEAR 2</Col>
					<Col>YEAR 3</Col>
				</Row>
			</div>
		);
	}
}

export default Header;
